<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top myfixed_nav">
      <a class="navbar-brand" href="javascript:void(0)" v-if="auth && (fullPath === '/engineer/skill-update' || fullPath === '/engineer/skill-update/')" >
        <img class="img-responsive logo" src="../../../assets/imgs/logo-blue.png"/>
        <span class="beta">&#946;
          <sub class="ver"> ver.</sub>
        </span>
      </a>
      <a v-else class="navbar-brand" href="javascript:void(0)" @click="redirectTo()">
        <img class="img-responsive logo" src="../../../assets/imgs/logo-blue.png"/>
        <span class="beta">&#946;
          <sub class="ver"> ver.</sub>
        </span>
      </a>
        <div class="navbar-nav" v-if="auth && (fullPath === '/engineer/skill-update' || fullPath === '/engineer/skill-update/')">
          <a href="javascript:void(0)"  @click='profile()'  >
              <button v-if="first_login == 1" class="btm mt-2 ml-4 btn bluebtn mplus2p-r spacing1-2 regnext_btn">{{$t('chat_back')}}</button>
              <button v-else  class="mt-2 ml-4 btn bluebtn mplus2p-r spacing1-2 regnext_btn">{{$t('ep_next')}}</button>
          </a>
        </div>
      <button class="navbar-toggler navbar-toggler-blue" type="button" data-toggle="collapse"
              data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-icon navbar-toggler-icon-blue"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent" >
        <ul class="navbar-nav ml-auto">

          <li class="nav-item " v-if=" (fullPath != '/engineer/nickname' && fullPath != '/engineer/nickname/') && auth">
            <div class="dropdown">
                <a href="javascript:void(0)" style="padding-right:0px" @click="clickedUserBtn()" class="nav-link blue dropdown-toggle" data-toggle="dropdown">
                  <img src="../../../assets/imgs/user_ico.png"/>
                </a>
                <div class="notification-container dropdown-menu dropdown-menu-right"  aria-labelledby="dropdownMenuButton">
                  <a v-if="role == 'engineer' && first_login > 0" class="dropitem" @click='profile()'>{{$t('header_profile')}}</a>
                  <a v-if="role == 'company_user'" class="dropitem" @click='myCompany()'>{{$t('header_my_company')}}</a>
                  <a v-if="role == 'company_user'" class="dropitem" @click='engineers()'>{{$t('header_engineers')}}</a>
                  <a class="dropitem"  @click='logout'>{{$t('header_logout')}}</a>
                </div>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import Hashids from "hashids";
  import axios from "axios";
  import VueI18n from "vue-i18n";
  import {EventBus} from "../../../main.js";

  export default {
    data() {
      return {
        userName: "",
        userId: "",
        companyId: "",
        role: "",
        showLoading: "",
        notifications: [],
        isNotificationLoading: false,
        notificationCount: "",
        notificationHide: false,
        first_login: '',
        fullPath: '',
        interview_completion: false,
        lan: 'jp'
      };
    },
    computed: {
      auth() {
        return this.$store.getters.isAuthenticated;
      },
    },
    mounted(){
      EventBus.$on("notificationCount", data => {
        this.markNotificationAsRead(data);
      });
      EventBus.$on("role", data => {
        this.role = data;
      });
      EventBus.$on("notificationHide", data => {
        this.notificationHide = data;
      });
      EventBus.$on("language", data => {
        this.lan = data;
      });
       EventBus.$on("firstLogin", data => {
        this.first_login = data;
      });
       EventBus.$on("complete_interview", data => {
        this.interview_completion = data;
      });
    },
     watch: {
      $route(to, from) {
        this.fullPath = to.fullPath;
      }
    },
    created() {
      this.fullPath = this.$route.fullPath;
      if ("lan" in localStorage) {
        this.lan = localStorage.getItem("lan");
      }
      if ("role" in localStorage) {
        this.role = localStorage.getItem("role");
      }
      if ("user" in localStorage) {
        var retrievedData = localStorage.getItem("user");
        var data = JSON.parse(retrievedData);
        if (data.nickname) {
          this.userName = data.nickname;
        }
        this.first_login = data.first_login;

        this.userId = data.id;
      }
      this.getNotificationCount();
      this.getInterviewCompleted();

    },
    methods: {
      getInterviewCompleted(){
        axios
          .get("interview-completion-flag?token=" + localStorage.getItem("token"), {
            headers: {"X-localization": localStorage.getItem("lan")}
          })
          .then(res => {
            this.interview_completion = res.data.interview_completed;
            if ('user' in localStorage) {
              var data = JSON.parse(localStorage.getItem("user"));
              data.completed_interview = res.data.interview_completed
              data.test_user = res.data.test_user
              localStorage.setItem("user",JSON.stringify(data));
            }
          })
          .catch(error => {
          });
      },
      redirectTo() {
        if (localStorage.getItem("user")) {
          if (localStorage.getItem('role') == 'engineer') {
            var data = JSON.parse(localStorage.getItem("user"));
            var userId = data.id;
            var userToken = data.user_token;
            this.$router.push("/engineer/profile/" + userToken)
          }
          if (localStorage.getItem('role') == 'company_user') {
            var data = JSON.parse(localStorage.getItem("user"));
            var userId = data.user_token;
            var companyId = data.company.company_token;
            this.$router.push("/company/company-user-profile/" + companyId + "/" + userId);
          }
        }
        else {
         this.$router.push("/global/signin");
        }
      },
      clickedLngBtn() {
         $('.dropitem').click(function (event) {
            $('.dropitem').removeClass('ddactive');
            //  $(this).addClass('ddactive');
          });
      },

      clickedUserBtn() {
        $('.dropitem').click(function (event) {
           $('.dropitem').removeClass('ddactive');
          // $(this).addClass('ddactive');
        });
        if ("user" in localStorage) {
          var retrievedData = localStorage.getItem("user");
          var data = JSON.parse(retrievedData);
          if (data.nickname) {
            this.userName = data.nickname;
          }

          this.role = localStorage.getItem("role");
        }
      },

      logout() {
        if ("fbUser" in localStorage) {
          FB.getLoginStatus(function (response) {
            if (response.status == "connected") {
              setTimeout(() => {
                FB.logout(response => {
                });
              }, 2000);
            }
          });

          this.$store.dispatch("logout");
          this.loading = false;
        } else {
          setTimeout(() => {
            this.$store.dispatch("logout");
            this.loading = false;
          }, 1000);
        }
      },
      profile() {
        //alert(id);
        if ($(".dropdown-content").removeClass("show"))
          $(".dropdown-content").removeClass("show");
        else $("#userDropdown").removeClass("hide");

        if (this.role == "engineer") {
          var retrievedData = localStorage.getItem("user");
          var data = JSON.parse(retrievedData);
          var userId = data.id;
          var userToken = data.user_token;
          data.first_login = 1
          var firstLogin = 1;
          localStorage.setItem("user",JSON.stringify(data))
          // EventBus.$emit("firstLogin", firstLogin);
          this.$router.push("/engineer/profile/" + userToken);
        }
        if (this.role == "company_user") {
          var retrievedData = localStorage.getItem("user");
          var data = JSON.parse(retrievedData);
          var userId = data.user_token;
          var companyId = data.company.company_token;
          this.$router.push(
            "/company/company-user-profile/" + companyId + "/" + userId
          );
        }
      },
      companies() {
        if ($(".dropdown-content").removeClass("show"))
          $(".dropdown-content").removeClass("show");
        else $("#userDropdown").removeClass("hide");
        this.$router.push({
          name: "engineerCompanyList",
          query: {page: 1}
        });
      },
      recruits() {
        if ($(".dropdown-content").removeClass("show"))
          $(".dropdown-content").removeClass("show");
        else $("#userDropdown").removeClass("hide");
        this.$router.push({
          name: "engineerRecruitList",
          query: {page: 1}
        });
      },
      myCompany() {
        var retrievedData = localStorage.getItem("user");
        var data = JSON.parse(retrievedData);
        var userId = data.user_token;

        var companyId = data.company.company_token;
        if ($(".dropdown-content").removeClass("show"))
          $(".dropdown-content").removeClass("show");
        else $("#userDropdown").removeClass("hide");
        this.$router.push("/company/profile/" + companyId + "/" + userId);
      },
      engineers() {
        if ($(".dropdown-content").removeClass("show"))
          $(".dropdown-content").removeClass("show");
        else $("#userDropdown").removeClass("hide");
        var data = JSON.parse(localStorage.getItem("user"));
        var userId = data.user_token;
        var companyId = data.company.company_token;
        this.$router.push({
          name: "engineerFavorite",
          params: {cid: companyId, uid: userId},
          query: {page: 1}
        });
      },

      clickedDDBtn(tid) {
        if ($(".dropdown-content").removeClass("show"))
          $(".dropdown-content").removeClass("show");
        else $("#myDropdown").removeClass("show");
        localStorage.setItem("lan", tid);
        this.$i18n.locale = localStorage.getItem("lan");
        $(".dropitem").removeClass("ddactive");
        $(tid).addClass("ddactive");
        EventBus.$emit("language", localStorage.getItem("lan"));
      },

      loadNewNotifications() {
        this.isNotificationLoading = true;
        axios
          .get("/notifications?token=" + localStorage.getItem("token"), {
            headers: {"X-localization": localStorage.getItem("lan")}
          })
          .then(res => {
            this.isNotificationLoading = false;
            if (this.notificationCount > 0) {
              if (res.data.notifications) {
                this.notifications = res.data.notifications;
              }
            } else {
              this.notifications = "";
            }
          })
          .catch(error => {
            this.isNotificationLoading = false;
          });
        this.$forceUpdate();
      },

      markNotificationAsRead(data) {
        let formData = {
          admin_mail : data.admin_mail
        }
        axios
          .post("mark/notification/read/" + data.id +"?token=" + localStorage.getItem("token"),formData, {
            headers: {"X-localization": localStorage.getItem("lan")}
          })
          .then(res => {
              this.getNotificationCount();
          })
          .catch(error => {
          });
      },

      goToChatPage(item) {
        if (item.type == `App\\Notifications\\FavoriteEngineerNotification`) {
         var retrievedData = localStorage.getItem("user");
        var data = JSON.parse(retrievedData);
        var userId = data.user_token;
        this.$router.push({
            name: "engineerFavoritedByCompany",
            params: { uid: this.userId },
            query: { page: 1 }
          });
          this.markNotificationAsRead({id :item.id , admin_mail: false});
        }
        if (item.type == `App\\Notifications\\FavoriteCompanyUserNotification`) {
          var data = JSON.parse(localStorage.getItem("user"));
          var userId = data.user_token;
          var companyId = data.company.company_token;
          this.$router.push({
            name: "CompanyInterestedEngineer",
            params: { cid: companyId, uid: userId },
            query: { page: 1 }
          });
          this.markNotificationAsRead({id :item.id , admin_mail: false});
        }
         if(item.type == `App\\Notifications\\MessageNotification`) {
          var userRole = localStorage.getItem("role");
          var hashids = new Hashids("this is my salt", 8, "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890");
          this.$router.push("/global/chatroom/"+ hashids.encode(item.data.item_id));
          this.markNotificationAsRead({id :item.id , admin_mail: false});
          }
      },

      getNotificationCount() {
        axios
          .get("unread/notification/count?token=" + localStorage.getItem("token"), {
            headers: {"X-localization": localStorage.getItem("lan")}
          })
          .then(res => {
            this.notificationCount = res.data.count;
            EventBus.$emit("notificationCounts", 1);
          })

          .catch(error => {
          });
        this.$forceUpdate();
      }
    }
  };
</script>

<style scoped>
  .notification-container {
    width: auto;
  }

  .notification-container p {
    white-space: normal;
  }

  .notification-container .avatar-img {
    width: 75px;
    height: 75px;
  }

  .mbadge {
    position: absolute;
    top: -1px;
    left: 30px;
  }
@media screen and (max-width: 678px) {
   .btm{
     margin-left: 20px !important;
   }
   .spacing1-2 {
    letter-spacing: 0.2px;
    }
  }

  @media screen and (max-width: 369px) {
  .btm{
     margin-left: 20px !important;
   }
   .spacing1-2 {
    letter-spacing: 0.2px;
    }
  }

  @media screen and (max-width: 768px) {
 .btm{
    margin-left: 20px !important;
   }
   .spacing1-2 {
    letter-spacing: 0.2px;
    }
  }

  .beta {
    color: #3d7dd8;
    position: absolute;
    /* padding-top: 17px; */
    font-size: 16px;
    margin-top: 7px;
    margin-left: 4px;
  }

</style>
